import React, { useEffect } from 'react'
import { graphql } from 'gatsby'

import * as Elements from '../components/elements'
import { Layout } from '../layout'
import { Head } from '../components/head'
import { PostTitle } from '../components/post-title'
import { PostDate } from '../components/post-date'
import { PostContainer } from '../components/post-container'
// import { SocialShare } from '../components/social-share'
// import { SponsorButton } from '../components/sponsor-button'
import { Bio } from '../components/bio'
import { PostNavigator } from '../components/post-navigator'
import { Disqus } from '../components/disqus'
import { Utterances } from '../components/utterances'
import TableOfContents from '../components/TableOfContents'
import * as ScrollManager from '../utils/scroll'
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import '../styles/code.scss'
import '../styles/post.scss'

import 'katex/dist/katex.min.css'
export default ({ data, pageContext, location }) => {
  useEffect(() => {
    ScrollManager.init()
    return () => ScrollManager.destroy()
  }, [])
  const post = data.markdownRemark
  const metaData = data.site.siteMetadata
  const { title, comment, siteUrl, author, sponsor } = metaData
  const { disqusShortName, utterances } = comment
  const { title: postTitle, date, parent, notable, category } = post.frontmatter
  const breakpoints = useBreakpoint();
  const visibleTable = !breakpoints.md && !notable;

  return (
    <Layout location={location} title={title} className={!visibleTable ? '' : 'blog-post-container'}>
      <div className={!visibleTable ? '' : 'content'}>
        <PostNavigator name={parent ? parent : null} category={category} href={(pageContext.slug).replace(/\/[^\/]+\/$/, "/00/")} />
        <Head title={postTitle} description={post.excerpt} />
        <PostTitle title={postTitle} />
        <PostDate date={date} />
        <PostContainer html={post.html} />
        {/* <SocialShare title={postTitle} author={author} />
      {!!sponsor.buyMeACoffeeId && (
        <SponsorButton sponsorId={sponsor.buyMeACoffeeId} />
      )} */}
        <Elements.Hr />
        {/* <Bio /> */}
        {/* <PostNavigator pageContext={pageContext} /> */}
        {!!disqusShortName && (
          <Disqus
            post={post}
            shortName={disqusShortName}
            siteUrl={siteUrl}
            slug={pageContext.slug}
          />
        )}
        {!!utterances && <Utterances repo={utterances} />}
      </div>
      <div>
        <br /><br /><br /><br />
        {!visibleTable ? null : <TableOfContents content={data.markdownRemark.tableOfContents} />}
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
        siteUrl
        comment {
          disqusShortName
          utterances
        }
        sponsor {
          buyMeACoffeeId
        }
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 280)
      html
      frontmatter {
        title
        date(formatString: "YYYY년 MM월 DD일 HH:mm")
        parent
        notable
        category
      }
      tableOfContents
    }
  }
`
